import { render, staticRenderFns } from "./SeminarList.vue?vue&type=template&id=8c7b0926&scoped=true&"
import script from "./SeminarList.vue?vue&type=script&lang=js&"
export * from "./SeminarList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c7b0926",
  null
  
)

export default component.exports